import type { Hole, LngLat } from './types.ts';

/** A real coordinate: two finite numbers, not the [0,0] null-island default. */
export function okCoord(p: unknown): p is LngLat {
  return (
    Array.isArray(p) &&
    p.length === 2 &&
    Number.isFinite(p[0]) &&
    Number.isFinite(p[1]) &&
    (p[0] !== 0 || p[1] !== 0)
  );
}

/**
 * A hole is only "mapped" if it can actually be measured: a real tee to stand
 * on and a real green to aim at. A par number alone (OSM's common case) is not
 * enough — without a green there is nothing to give a yardage to, and pretending
 * otherwise is what produced the fake "Hole 1 · par 4" with a frozen distance.
 */
export function holeHasGeometry(h: Hole): boolean {
  const tees = h.tees ? Object.values(h.tees) : [];
  const hasTee = tees.some(okCoord);
  return hasTee && okCoord(h.green?.middle);
}
